module.exports = __webpack_public_path__ + "static/media/decaf.435c7359.JPG";